import { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Flex,
  Stack,
  Image,
  Box,
  Progress,
} from "@chakra-ui/react";
import {
  PrivateInteraction,
  PublicInteraction,
  TweetInteraction,
  SalesNavSearch,
  Url,
  Preview,
} from "components/add-people";
import { AddFromList } from "components/dm/add-from-list";
import { ModalInfoIcon } from "./ModalInfoIcon";
import { layerStyle, textStyle, variant } from "theme/names";
import { isFeatureEnabled } from "utils/helpers";

interface Props {
  onClose: () => void;
  isOpen: boolean;
  title: string;
  onAdd: (people: any[]) => void;
  mode?: "dm" | "list";
  dataLoaderAdd?: any;
  session?: any;
}

export function AddPeople({
  onClose,
  isOpen,
  title,
  onAdd,
  mode = "list",
  dataLoaderAdd = {},
  session = {},
}: Props) {
  const [listOfPeople, setListOfPeople] = useState<any>([]);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const tempAddPeople = (people: any[]) => {
    let newList = [...listOfPeople];
    people.forEach((p) => {
      if (!listOfPeople.some((el) => el.id === p.id)) {
        newList.push(p);
      }
    });

    setListOfPeople(newList);
  };

  useEffect(() => {
    if (!isOpen) {
      setListOfPeople([]);
    }
  }, [isOpen]);

  return (
    <Modal onClose={onClose} size="3xl" isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
        // fontWeight="bold"
        >
          {/* <ModalInfoIcon /> */}
          {title}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          {mode === "dm" &&
            isFeatureEnabled("outreach", session, {}, false, "") && (
              <AddFromList addPeople={tempAddPeople} />
            )}
          <Url addPeople={tempAddPeople} />
          {isFeatureEnabled("addPeopleInBulk", session, {}, false, "") && (
            <Box mt="12">
              <Text textStyle={textStyle["h4.bold.standard"]}>Add in bulk</Text>
              <Text textStyle={textStyle["body.medium.light"]} mt={1}>
                We do not support dynamic lists yet. Lists can only be updated
                manually.
              </Text>
              <Stack
                mt="4"
                spacing="6"
                layerStyle={layerStyle["bg.border.rounded"]}
                p={4}
              >
                {/* <PublicInteraction addPeople={tempAddPeople} /> */}
                {/* <PrivateInteraction addPeople={tempAddPeople} /> */}
                <SalesNavSearch addPeople={tempAddPeople} />
                <TweetInteraction addPeople={tempAddPeople} />
              </Stack>
            </Box>
          )}
          <Box mt="8" textAlign="center">
            <Text
              textStyle={textStyle["body.medium.light"]}
              fontWeight="bold"
              display="block"
            >
              Preview of people
            </Text>
            <Preview people={listOfPeople} />
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center" flexDir="column">
          {dataLoaderAdd?.total > 0 && isSaving && (
            <Box w="100%" h="40px">
              <Progress
                size="xs"
                rounded="full"
                value={Math.floor(
                  (dataLoaderAdd?.done / dataLoaderAdd?.total) * 100
                )}
              />
            </Box>
          )}
          <Button
            variant={variant.Button.primary}
            // colorScheme="blue"
            // bg="blue.700"
            // color="white"
            // _hover={{ bg: "blue.600" }}
            onClick={async () => {
              try {
                setIsSaving(true);
                await onAdd(listOfPeople);
                setListOfPeople([]);
              } catch (e) {
                console.log("Error in adding people to the list: ", e);
              } finally {
                setIsSaving(false);
              }
            }}
            isLoading={isSaving}
            isDisabled={listOfPeople.length === 0}
          >
            Add People
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
